/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Row, Col } from 'antd'

// css
import { BettingFoldGrouped } from '@store/bettingHistoryStore'
import { SPECIAL_META } from '@store/oddsStore'
import { BettingHistoryLeagueWrap, SpecialGame, TeamWrap } from './index.style'

import BettingHistoryListItemFoldSpecial from './BettingHistoryListItemFoldSpecial'

// // icon
// const Emblem = [<img src={SuwonFC} alt="팀 앰블럼" />, <img src={BucheonFC} alt="팀 앰블럼" />]

interface BettingHistoryListItemSpecialProps {
  fold: BettingFoldGrouped
  close1: number
  close2: number
}

const BettingHistoryListItemSpecial: React.FC<BettingHistoryListItemSpecialProps> = (
  props: BettingHistoryListItemSpecialProps,
) => {
  const { fold, close1, close2 } = props
  const { sportId } = fold
  const meta = SPECIAL_META[sportId]
  const gameName = meta.name

  const eleFolds = []
  for (const el of fold.data) {
    eleFolds.push(<BettingHistoryListItemFoldSpecial fold={fold} foldData={el} close1={close1} close2={close2} />)
  }

  return (
    <BettingHistoryLeagueWrap>
      <Row type="flex" justify="space-between" className="row">
        <Col className="col special">
          <SpecialGame>{gameName}</SpecialGame>
          <TeamWrap className="special">
            {/* 소수점 승무패 */}
            {/* <TeamNameTxt className="special-num">
              {close1Front}
              <span className="point">{close1End}</span>
            </TeamNameTxt> */}

            {/* 소수점 끝자리의 평균 홀짝 */}
            {/* <TeamNameTxt className="special-num">
              {close2Front}
              <span className="point">{close2End}</span>
            </TeamNameTxt> */}
          </TeamWrap>
        </Col>
      </Row>
      {eleFolds}
    </BettingHistoryLeagueWrap>
  )
}

export default BettingHistoryListItemSpecial
